import React, { Component } from 'react';
import { Tag, Input, Tooltip, Icon, Menu, Dropdown } from 'antd';
import _ from 'lodash';


export default class EditableTagGroup extends Component {
  state = {
    tags: this.props.tags,
    options: this.props.options,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  removeTag(removedTag) {
    const tags = this.props.tags.filter(tag => tag !== removedTag);
    this.props.remove(removedTag);
    this.setState({ tags });
  };

  addTag(addedTag) {
    const tags = this.props.tags.push(addedTag);
    this.props.add(addedTag);
    this.setState({ tags });
  }

  renderDropDown() {
    const { tags, options } = this.state;
    const availableOptions = _.difference(options, tags);
    if(!availableOptions.length) return;
    const _options = _.map(availableOptions,
      (item) => <Menu.Item key={item}>
        <a
          target={item}
          rel="noopener noreferrer"
          onClick={() => this.addTag(item)}
        >{item}</a>
      </Menu.Item>);
    const __menu = <Menu>{_options}</Menu>;
    return <div className="editable-cell-input-wrapper">
      <Dropdown overlay={__menu} className='add-text'>
        <a className="ant-dropdown-link"
           href="#">
          + <Icon type="down"/>
        </a>
      </Dropdown>
    </div>;
  }

  render() {
    const { tags } = this.state;
    return (
      <div>
        {
          _.map(tags, (tag, i) => {
            return <Tag key={i} closable={true} onClose={(e) => {
              e.preventDefault();
              return this.removeTag(tag)
            }}>{tag}</Tag>
          })
        }
        {this.renderDropDown()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/editable-tag-group/EditableTagGroup.js